<all-simulations-table
  *ngIf="shouldShowAllSimulationsTable()"
  [selectedAccount]="selectedAccount"
  [selectedAccountUuid]="selectedAccountUuid"
  [selectedAccountHasAuthor]="selectedAccountHasAuthor"
  [selectedAccountHasAssignmentManager]="selectedAccountHasAssignmentManager"
  (deleteSimulation)="onDeleteSimulation($event)"
  (duplicateSimulation)="onDuplicateSimulation($event)"
  [refreshKey]="refreshKey"
></all-simulations-table>

<published-simulations-table
  *ngIf="shouldShowPublishedSimulationsTable()"
  [selectedAccount]="selectedAccount"
  [selectedAccountUuid]="selectedAccountUuid"
></published-simulations-table>
